export default {
  allCalls: 'All calls',
  Unknown: 'Unknown',
  Multiple: 'Multiple',
} as const;
